import { TwilioVerificationChannelEnum, useUserCheckEmailTaken } from '@alluradirect/react';
import { useFormikContext } from 'formik';
import { FormikAppEmail } from 'components/formik/core/FormikAppEmail/FormikAppEmail';
import FormikPhoneNumber from 'components/formik/core/FormikPhoneNumber/FormikPhoneNumber';
import { SendCodeValues } from 'components/views/verification/components/SendCodeFormWrapper';
import { CircularProgress, InputAdornment } from '@mui/material';

interface Props {
  channel: TwilioVerificationChannelEnum.sms | TwilioVerificationChannelEnum.email;
}

export const SendCodeField = ({ channel }: Props) => {
  const { values, isValid, setFieldValue, isSubmitting } = useFormikContext<SendCodeValues>();

  const emailTaken = useUserCheckEmailTaken({
    email: values.data,
    enabled: channel === TwilioVerificationChannelEnum.email && isValid && values.data.length >= 3,
    onSuccess: data => {
      setFieldValue('is_taken', data?.DATA?.IS_EMAIL_TAKEN ?? false);
    },
  });

  const isLoadingTakenData = emailTaken.isLoading;

  if (channel === TwilioVerificationChannelEnum.email) {
    return (
      <FormikAppEmail
        name={'data'}
        autoFocus
        onChange={() => setFieldValue('is_taken', false)}
        endAdornment={
          isLoadingTakenData ? (
            <InputAdornment position="end">
              <CircularProgress size={14} thickness={1} color="primary" />
            </InputAdornment>
          ) : undefined
        }
      />
    );
  }

  if (channel === TwilioVerificationChannelEnum.sms) {
    return (
      <FormikPhoneNumber
        name={'data'}
        autoFocus
        onChange={() => setFieldValue('is_taken', false)}
        disabled={isSubmitting}
      />
    );
  }

  return null;
};
